import React, { Fragment } from 'react'
import messages from '@App/session/messages'
import styled from 'styled-components'
import { HubFormattedMessage } from 'src/common/rtl/HubTextFormatting'
import { BackLink, ResetPasswordDescription } from './index'

type Props = {
  onCloseResetPassword: () => void
  emailAddress: string
}

const RequestResetPasswordSentDialog: React.FC<Props> = (props: Props) => {
  const { onCloseResetPassword, emailAddress } = props

  return (
    <Fragment>
      <h1>
        <HubFormattedMessage {...messages.magicLinkSuccessHeader} />
      </h1>
      <ResetPasswordDescription>
        <HubFormattedMessage
          {...messages.magicLinkSuccessBody}
          values={{
            email: <b>{emailAddress}</b>,
          }}
        />
      </ResetPasswordDescription>
      <BackLinkContainer>
        <BackLink onClick={onCloseResetPassword}>
          <HubFormattedMessage {...messages.closeResetPasswordSent} />
        </BackLink>
      </BackLinkContainer>
    </Fragment>
  )
}

const BackLinkContainer = styled.div`
  text-align: center;
`

export default RequestResetPasswordSentDialog
